import I18n from 'i18n-js';
import React from 'react';

export default class LastCourseViewed extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hidden: false
		};

		this.onHide = this.onHide.bind(this);
	}

	render() {
		if (this.state.hidden) {
			return null;
		} else {
			return (
				<div
					className={
						'last-course-viewed ' +
						(this.props.viewport ? this.props.viewport : ' desktop') +
						(this.props.number ? ' has-number' : '')
					}
				>
					<label>{I18n.t('last_course_viewed')}</label>

					<div className="row">
						<div className="col-xs-4">
							<a href={this.props.path} className="course-image-rounded">
								<img
									src={this.props.image_src}
									alt={'Stock image of ' + this.props.name}
								/>
								{this.props.number ? (
									<span className="number">{this.props.number}</span>
								) : null}
							</a>
						</div>

						<div className="col-xs-8">
							<div className="course-name">
								<a href={this.props.path}>{this.props.name}</a>
							</div>
							<div className="course-progress">
								<div className="progress-bar-chart">
									<div
										className="progress-amount"
										style={{ width: this.progressPercentage() + '%' }}
									/>
								</div>
								<div className="progress-percentage">
									{this.progressPercentage()}% <span>PROGRESS</span>
								</div>
								{this.renderQuizScore()}
							</div>
						</div>
					</div>

					{/*this.props.viewport == 'mobile' ? (
						<span className="fa fa-close" onClick={this.onHide}>
							&nbsp;
						</span>
          ) : null*/}
				</div>
			);
		}
	}

	renderQuizScore() {
		//console.log('render Quiz Score', this.props.last_quiz_score);
		if (this.props.last_quiz_score != null) {
			return (
				<div className="quiz-score">
					<span style={{ textTransform: 'uppercase' }}>
						{I18n.t('quiz')}
					</span>{' '}
					{Math.round(this.props.last_quiz_score * 100)}%
				</div>
			);
		}
	}

	progressPercentage() {
		var percentage = Math.round(this.props.progress * 100);

		if (percentage > 100) {
			return 100;
		} else if (percentage < 0) {
			return 0;
		} else {
			return percentage;
		}
	}

	onHide() {
		this.setState({ hidden: true });
	}
}
